var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import clsx from 'clsx';
import { trackEvent } from '../../utils/trackPulse';
import { consume } from '@lit-labs/context';
import { feedbackContext } from './FeedbackContext';
let Stepper = class Stepper extends BaseComponent {
    render() {
        const { questions } = this.questionsAndStatus.feedbackStatusAndQuestions;
        const { answers, textReview, active } = this.questionsAndStatus;
        const nrOfQuestions = questions.length;
        const steps = Array(nrOfQuestions + 1).fill({ completed: false }).map((_, i) => {
            if (i < answers.length || (i === nrOfQuestions && textReview && textReview !== '')) {
                return { completed: true };
            }
            return { completed: false };
        });
        return html `
      <ul class="m-auto w-full max-w-[${(nrOfQuestions) * 200}px] flex justify-around leading-16 text-left">
        ${steps.map((step, index) => {
            const isActive = active === index;
            const lastStep = index === steps.length - 1;
            const stepClass = clsx({
                'w-full': !lastStep,
                'text-center relative rounded-full': true,
                'border-stepper--hover cursor-pointer': !isActive && index <= answers.length,
            });
            const lineClass = clsx({
                'w-full h-[2px] absolute top-[7px] z-0': true,
            }, index < active || index < answers.length - 1 ? 'bg-stepper' : 'bg-bluegray');
            const circleClass = clsx('w-16 h-16 relative block content-[\'\'] box-content text-center rounded-full border-[2px] border-solid z-[2]', isActive ? 'bg-white border-stepper' : step.completed ? 'bg-stepper border-stepper' : 'border-bluegray bg-white', !isActive && index <= answers.length ? 'hover:border-stepper--hover hover:bg-white' : '');
            return (html `
              <li class='${stepClass}' id='steps-${index}' tabindex=${index <= answers.length ? '0' : '-1'}
                  data-test='${`stepper-${index}`}'
                  @click='${() => this.setActiveStep(index)}'
                  aria-disabled='${index > answers.length}'
              >
                ${!lastStep
                ? html `
                    <div class='${lineClass}'></div>`
                : nothing}
                <div class='${circleClass}'>
                  <trust-icon name="Checkmark" classNames="absolute w-10 h-10 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"></trust-icon>
                </div>
              </li>
            `);
        })}
      </ul>
    `;
    }
    setActiveStep(newValue) {
        const { answers, active, setActive } = this.questionsAndStatus;
        if (newValue <= answers.length) {
            trackEvent({
                name: 'Navigate to another step',
                intent: 'Open',
                type: 'Click'
            }, newValue > active ? 'Navigate forward' : 'Navigate back', 'Trust feedback stepper', this.vertical, `Review step ${newValue + 1}`);
            setActive(newValue);
        }
    }
};
__decorate([
    property({ type: Object })
], Stepper.prototype, "vertical", void 0);
__decorate([
    consume({ context: feedbackContext, subscribe: true })
], Stepper.prototype, "questionsAndStatus", void 0);
Stepper = __decorate([
    customElement('trust-feedback-stepper')
], Stepper);
export { Stepper };
// max-w-[100px]
// max-w-[200px]
// max-w-[300px]
// max-w-[400px]
// max-w-[500px]
// max-w-[600px]
// max-w-[700px]
// max-w-[800px]
// max-w-[900px]
//# sourceMappingURL=Stepper.js.map